import React from 'react';

const IconSquareUncheck = () => (
  <g>
    <rect x="1.5" y="1.5" width="17" height="17" rx="3.5" stroke="#4B555F" />
  </g>
);

export default IconSquareUncheck;
